<template>
  <div
    ref="fieldContextMenu"
    class="absolute"
    data-test="field-context-menu"
  >
    <ContextMenu
      :buttons="buttons"
      @cut="cutField"
      @copy="copyField"
      @paste="pasteField"
      @delete="deleteField"
      @closeContextMenu="closeContextMenu" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ContextMenu from '@/components/tailwind/ContextMenu.vue';

  export default {
    name: 'FieldContextMenu',
    components: {
      ContextMenu,
    },
    data() {
      return {
        pasteCoordinates: null,
        left: 0,
        top: 0,
        buttons: {
          cut: {
            label: this.$t('functional.cut'),
            icon: 'cut',
            isDisabled: true,
          },
          copy: {
            label: this.$t('functional.copy'),
            icon: 'copy',
            isDisabled: true,
          },
          paste: {
            label: this.$t('functional.paste'),
            icon: 'paste',
            isDisabled: true,
          },
          delete: {
            label: this.$t('functional.delete'),
            icon: 'trash',
            isDisabled: true,
          },
        },
      };
    },
    computed: {
      ...mapGetters({
        clipboard: 'fields/clipboard',
      }),
    },
    methods: {
      initialiseContextMenu(menuOpenedOnField) {
        this.resetButtons();
        if (this.clipboard) {
          this.enableButton('paste');
        }
        if (menuOpenedOnField) {
          this.enableButton('copy');
          this.enableButton('cut');
          this.enableButton('delete');
        }
      },
      resetButtons() {
        this.disableButton('cut');
        this.disableButton('copy');
        this.disableButton('paste');
        this.disableButton('delete');
      },
      positionContextMenu(left, top, pasteCoordinates) {
        this.pasteCoordinates = pasteCoordinates;
        this.left = left;
        this.top = top;
        this.$refs.fieldContextMenu.style.left = `${this.left}px`;
        this.$refs.fieldContextMenu.style.top = `${this.top}px`;
      },
      disableButton(key) {
        this.buttons[key].isDisabled = true;
      },
      enableButton(key) {
        this.buttons[key].isDisabled = false;
      },
      cutField() {
        this.$emit('cutField');
        this.enableButton('paste');
      },
      copyField() {
        this.$emit('copyField');
        this.enableButton('paste');
      },
      pasteField() {
        if (this.clipboard) {
          this.$emit('pasteField', { left: this.pasteCoordinates.left, top: this.pasteCoordinates.top });
        }
      },
      deleteField() {
        this.$emit('deleteField');
      },
      closeContextMenu() {
        this.$emit('closeFieldContextMenu');
      },
    },
  };
</script>
